export default ".callback-container{display:flex;justify-content:center;align-items:center;height:60vh;text-align:center}.loader img{margin-bottom:20px}";